import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import postAddPost from '../../../api/graphql/mutations/postAddPost';
import StructureLanguageTabs from '../DragAndDrop/StructureLanguageTabs';
import slugify from '../../../utils/slugify';
import checkPostSlugNameRepeated from '../../../utils/checkPostSlugNameRepeated';
import Notificacion from '../../Notification';


const AddCategoryForm = (props) => {
  const initialState = {
    slugName: '',
    postName: '',
    postDescription: {
      title: {
        en: '',
      },
      image: {
        en: '',
      },
    },
    postCategory: [],
    type: 'section',
    components: String(
      JSON.stringify([
        {
          type: 'Body',
          slugName: '',
          components: [],
        },
      ]),
    ),
  };

  const [postInfo, setPostInfo] = useState(initialState);
  const [status, setStatus] = useState({ status: 'creating', text: '' });

  useEffect(() => {}, []);

  const sendPost = async () => {
    if (postInfo.postDescription.title.en) {
      const slugNameRepeated = await checkPostSlugNameRepeated(`pc-${slugify(postInfo.postDescription.title.en)}`);
      if (!slugNameRepeated) {
        console.log('creating...');
        const post = {
          ...postInfo,
          slugName: `pc-${slugify(postInfo.postDescription.title.en)}`,
        };
        postAddPost(post)
          .then(({ isAdded }) => {
            if (!isAdded) {
              setStatus({ status: 'error', text: 'The category was not created' });
            } else {
              setStatus({ status: 'created', text: 'Ok', color: 'green' });
              props.reFetch();
            }
          })
          .catch(err => console.log(err));
      } else {
        setStatus({ status: 'error', text: 'Category already taken', color: 'red' });
      }
    }
  };

  const handleLangInput = (e) => {
    const { value, name } = e.target;
    const postState = {
      ...postInfo,
      postName: slugify(value),
      postDescription: {
        ...postInfo.postDescription,
        [name]: {
          en: value,
        },
      },
    };
    setPostInfo(postState);
  };

  const postTitle = postInfo.postDescription.title;
  const postImage = postInfo.postDescription.image;
  const { handleClick } = props;
  return (
    <div className="category-create p-6">
      <div className="bg-greyWithinForm p-4 rounded-t-lg">
        <span className="font-americaMonoBold text-sm uppercase text-white">Create Post Category</span>
      </div>
      <div className="bg-greyFilter text-white py-4 flex flex-wrap w-98 px-5 rounded-b-lg pb-1">
        <label className="font-americaMonoRegular text-xs uppercase my-2 w-full text-black" htmlFor="postTitle">
          Title
          <input className="font-americaMonoRegular p-2 bg-white outline-none w-full mt-4 rounded-full" onChange={handleLangInput} name="title" type="text" value={postTitle.en} />
        </label>
        <label className="font-americaMonoRegular text-xs uppercase my-2 w-full text-black" htmlFor="postTitle">
          Image
          <input className="font-americaMonoRegular p-2 bg-white outline-none w-full mt-4 rounded-full" onChange={handleLangInput} name="image" type="text" value={postImage.en} />
        </label>
      </div>
      <div className="flex justify-between py-4 p-4">
        <Notificacion text={status.text} color={status.color} />
        <div>
          <button className="mr-2 font-americaMonoBold text-xs px-6 py-2 bg-black border border-white rounded-full text-grey uppercase" onClick={handleClick} type="button">
            Cancel
          </button>
          <button className="font-americaMonoBold text-xs px-6 py-2 rounded-full uppercase bg-greyFilter text-black uppercase" onClick={sendPost} type="button" disabled={!postTitle.en}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

AddCategoryForm.propTypes = {
  handleClick: PropTypes.func.isRequired,
  reFetch: PropTypes.func.isRequired,
};

export default AddCategoryForm;
